<template>
  <div class="content-body chat-container chat-private">
    <div class="table-chat chat">
      <chat-filter></chat-filter>

      <ul id="privateMessages" class="stream list-group list-group-flush private" ref="messagesTable">
        <li v-if="!privateChatTarget">
          <div class="msg-container">
            <div class="message-item info-message">
              <div class="chat-help">
                <div class="help-ico"><i class="fa fa-info-circle" aria-hidden="true"></i></div>
                <div class="help-info">
                  <ul>
                    <li>These messages are private between you and the recipient.</li>
                    <li>All of your private messages are collected here in one stream for easy viewing.</li>
                    <li>
                      Click the chat bubble next to a person's name
                      <i aria-hidden="true" class="ar-icon user_in icon-comment-alt-light"></i> to send a new private
                      message, reply or filter by that person.
                    </li>
                    <li>Use the "Contacts" filter to see messages you have sent or replied to.</li>
                    <li>Use the "Other" filter to see inbound messages to which you have not replied.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
        <chat-message
          v-for="(message, index) in messages"
          :key="'privateMessage-' + index"
          :message="message"
          type="PRIVATE"
        ></chat-message>
      </ul>

      <div v-if="privateChatTarget && !isUserFromPublic" class="message-new">
        <chat-input
          v-model="message"
          :placeholder="'private message to ' + getRecipientFullName"
          :group="group"
          @send-message="sendMessage()"
          @emoji-picked="emojiPicked($event)"
        ></chat-input>
      </div>
    </div>
  </div>
</template>

<script>
import ChatMixin from "@/components/DigitalEvent/RoomList/Room/mixins/ChatMixin";
import ChatInput from "@/components/DigitalEvent/RoomList/Room/Chat/components/ChatInput";
import ChatFilter from "@/components/DigitalEvent/RoomList/Room/Chat/components/ChatFilter";
import { mapGetters, mapState } from "vuex";

export default {
  name: "PrivateMessages",
  mixins: [ChatMixin],
  components: {
    "chat-input": ChatInput,
    "chat-filter": ChatFilter
  },
  methods: {
    sendMessage() {
      if (!this.canSendMessage) {
        return;
      }
      this.$store.dispatch("chat/sendPrivateMessage", { message: this.message });

      this.message = "";
    }
  },
  computed: {
    ...mapState("chat", {
      privateChatTarget: "privateChatTarget"
    }),
    ...mapGetters({
      group: "tables/userTable",
      messages: "chat/privateMessages",
      publicTableUsers: "tables/publicTableUsers",
      getUser: "users/getUser",
      getUserFullName: "users/getUserFullName"
    }),
    isUserFromPublic() {
      return this.publicTableUsers.some(user => user.userUUID === this.privateChatTarget.userUUID);
    },
    getRecipientFullName() {
      return this.getUserFullName(this.privateChatTargetUser);
    },
    privateChatTargetUser() {
      return this.getUser(this.privateChatTarget.userUUID);
    }
  }
};
</script>
